import { TopBar } from '../../top-bar/TopBar';
import { PublicOptions } from '../../../data/publicOptions';
import { Footer } from '../../footer/Footer';
import './Workshops.css';
import BannerTop from '../../../assets/special-events/SNN2026_BANNER Social event-01.jpg';
import BannerMiddle from '../../../assets/special-events/SNN2026_BANNER Social event-02.png';
import BannerBottom from '../../../assets/special-events/SNN2026_BANNER Social event-03.jpg';
import {useState} from "react";

export const Workshops = () => {
  const [currentTab, setCurrentTab] = useState('forum');
  return (
    <>
      <TopBar options={PublicOptions} />
      <div className="content">
          <div>
            <nav className="snn-submenu">
                <ul>
                    <li className={currentTab === 'forum' ? 'active' : ''} onClick={() => setCurrentTab('forum')}>
                        Forum
                    </li>
                    <li className={currentTab === 'workshops' ? 'active' : '' } onClick={() => setCurrentTab('workshops')}>
                        Workshops
                    </li>
                    <li className={currentTab === 'contact-us' ? 'active' : '' } onClick={() => setCurrentTab('contact-us')}>
                        Chat with Us
                    </li>
                </ul>
            </nav>
          </div>
        {currentTab === 'forum' &&
            <>
              <section className="page-section snn-banner">
                <div>
                  <img src={BannerTop} alt="Banner"/>
                </div>
              </section>
              <section className="snn-page-section">
                <div className="grid-description-workshop">
                  <div>
                    <h1 className="snn-section-title">Energy Transition: Challenges and Opportunities for
                      Nanotechnology</h1>
                    <p>
                      This forum brings together leaders from government and industry, together with scientists and
                      innovators, to explore how collaboration among these sectors can drive innovation and improve
                      quality of
                      life in our communities.
                    </p>
                    <p>
                      Through moderated discussions and interactive Q&amp;A sessions, participants will explore the
                      following
                      key topics:
                    </p>
                    <ul>
                      <li>Research and innovation challenges in the current energy transition</li>
                      <li>Challenges in translating research into industrial applications</li>
                      <li>Opportunities for collaboration and technology transfer</li>
                      <li>Future trends shaping science–industry partnerships in the energy sector</li>
                    </ul>
                    <p>
                      Whether you are a researcher, entrepreneur, or student interested in applied science and its
                      impact on
                      industry, this forum offers a unique opportunity to connect, exchange ideas, and gain insights
                      into the
                      evolving landscape of science-driven innovation.
                    </p>
                    <p>
                      Join us for a meaningful dialogue that helps shape the future of collaboration among research,
                      industry,
                      and government.
                    </p>
                    <p><strong>Please note:</strong> the forum will be conducted in Spanish.</p>
                  </div>
                  <div>
                    <h1 className="snn-section-title">Transición Energética: Retos y Oportunidades para la
                      Nanotecnología</h1>
                    <p>
                      Este foro reúne a líderes del gobierno y la industria, junto con científicos e innovadores, para
                      explorar cómo la colaboración entre estos sectores puede impulsar la innovación y mejorar la
                      calidad de
                      vida en nuestras comunidades.
                    </p>
                    <p>
                      A través de mesas moderadas y sesiones interactivas de preguntas y respuestas, los participantes
                      abordarán los siguientes temas clave:
                    </p>
                    <ul>
                      <li>Retos de la investigación y la innovación en la actual transición energética</li>
                      <li>Desafíos para trasladar los resultados de la investigación a aplicaciones industriales</li>
                      <li>Oportunidades de colaboración y transferencia tecnológica</li>
                      <li>Tendencias futuras en las alianzas ciencia–industria dentro del sector energético</li>
                    </ul>
                    <p>
                      Ya seas investigador, emprendedor o estudiante interesado en la ciencia aplicada y su impacto en
                      la
                      industria, este foro ofrece una oportunidad única para establecer contactos, intercambiar ideas y
                      obtener una visión más amplia del panorama actual de la innovación impulsada por la ciencia.
                    </p>
                    <p>
                      Únete a nosotros para participar en un diálogo significativo que contribuya a dar forma al futuro
                      de la
                      colaboración entre investigación, industria y gobierno.
                    </p>
                    <p><strong>Nota:</strong> el foro se llevará a cabo en español.</p>
                  </div>
                </div>

              </section>
            </>
        }
        {currentTab === 'workshops' &&
            <>
              <section className="page-section snn-banner">
                <div>
                  <img src={BannerBottom} alt="Banner"/>
                </div>
              </section>
              <section className="snn-page-section">
                <p>
                  SNN2026 is pleased to announce the opening of its workshop session scheduled for Monday,
                  May 11th. The cost per workshop is $250 MXN in cash, and no invoices will be issued—only
                  proof of payment. Payment must be made on Monday, May 11th, prior to attending the
                  workshop. Participants may select only one workshop, as space is limited.
                </p>
              </section>
            </>
        }
        {currentTab === 'contact-us' &&
            <>
                <section className="page-section snn-banner">
                    <div>
                        <img src={BannerMiddle} alt="Banner"/>
                    </div>
                    <section className="snn-page-section">
                        <p>
                            We are excited to introduce a new activity at this year’s symposium: <strong>&quot;Chat with
                            Us&quot;</strong>, an
                            informal evening gathering designed to encourage open communication between invited
                            speakers, attendees,
                            and
                            students.
                        </p>
                        <p>
                            This event offers a relaxed and friendly atmosphere where participants can enjoy their
                            favorite drink
                            while
                            engaging in meaningful conversations about science, research, and academic life. It&apos;s a
                            unique
                            opportunity
                            to:
                        </p>
                        <ul>
                            <li>Ask questions outside of formal sessions</li>
                            <li>Exchange ideas with leading scientists</li>
                            <li>Discuss career paths, research challenges, and future directions</li>
                            <li>Network across discipline</li>
                        </ul>
                        <p>
                            <strong>&quot;Chat with Us&quot;</strong> breaks down the usual barriers between speakers
                            and audience,
                            encouraging
                            direct dialogue in an open, informal environment. Whether you&apos;re a student looking for
                            guidance or a
                            researcher eager to connect, this event is designed to support genuine interaction and
                            collaboration.
                        </p>
                        <p>
                            We warmly invite all symposium participants to join us and make the most of this new
                            initiative!
                        </p>
                    </section>
                </section>
            </>
        }


      </div>
        <Footer/>
    </>
  );
};
